module.exports = __webpack_public_path__ + "static/img/view10-6.52a3203.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view10-6.png
// module id = OKrH
// module chunks = 1